import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import UserDataGrid from '../UserDataGrid/UserDataGrid';
import UserList from '../UserList/UserList';

const Users: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <UserDataGrid />
      </If>
      <If condition={!isDesktop}>
        <UserList />
      </If>
    </>
  );
};

export default React.memo(Users);